import { closePopup, openPopup, includePopups } from "./popup";

includePopups();

const consentPopup = document.querySelector('.consent')
const consentForm1 = document.getElementById('consentForm1');
const consentForm2 = document.getElementById('consentForm2');

const btnAccept = document.getElementById('consentBtnAccept');
const btnCookies = document.getElementById('consentBtnCookies');
const btnSave = document.getElementById('consentBtnSave');
const btnReset = document.getElementById('btnResetCookies');

const consentCheckbox = document.getElementById('consentPersonal');

let consent = localStorage.getItem('consent');

if(consent != "true" && consent != "false") {
    openPopup(consentPopup);
}

const saveConsent = function(consent) {
    localStorage.setItem("consent", consent);
    consentForm1.submit();
}

const loadForm2 = function() {
    consentForm1.classList.add('hidden');
    consentForm2.classList.remove('hidden');
}

const resetConsent = function() {
    localStorage.removeItem("theme");
    localStorage.removeItem("consent");
}

const getFormInput = function() {
    consent = consentCheckbox.checked;
    if(!consent) resetConsent();
    localStorage.setItem("consent", consent);
    consentForm2.submit();
}

btnAccept.addEventListener('click', function(e) {
    e.preventDefault();
    saveConsent(true);
});

btnCookies.addEventListener('click', function(e){
    e.preventDefault();
    loadForm2();
});

btnSave.addEventListener('click', function(e) {
    e.preventDefault();
    getFormInput();
});

btnReset.addEventListener('click', function(e) {
    e.preventDefault();
    openPopup(consentPopup);
})